import { api } from '../../../api/client';
import type { Element, Schedule, UrgencySettings } from '@thekwallace/backtime-shared';

/**
 * Default settings that can be saved/loaded
 */
export interface DefaultSettings {
  elements?: Element[];
  schedule?: Schedule;
  urgencySettings?: UrgencySettings | null;
  timezone?: string;
  isAutoAdvanceEnabled?: boolean;
  autoAdvanceBuffer?: number;
  selectedStartTime?: string | null;
}

/**
 * Defaults service for saving and loading default configurations
 */
const defaultsService = {
  /**
   * Save current state as defaults to backend
   */
  async saveDefaults(userId: string, state: DefaultSettings): Promise<boolean> {
    if (!userId) {
      throw new Error('User ID is required to save defaults');
    }

    try {
      await api.put(`/users/${userId}/settings/defaults`, state);
      return true;
    } catch (error) {
      console.error('Error saving defaults to cloud:', error);
      throw error;
    }
  },

  /**
   * Load defaults from backend
   */
  async loadDefaults(userId: string): Promise<DefaultSettings | null> {
    if (!userId) {
      throw new Error('User ID is required to load defaults');
    }

    try {
      const response = await api.get<{ settings: DefaultSettings }>(`/users/${userId}/settings/defaults`);
      // Backend returns { settings: {...} }
      return response.settings || null;
    } catch (error) {
      console.error('Error loading defaults from cloud:', error);
      return null;
    }
  }
};

export default defaultsService;
